import React, { memo } from 'react'
import { faScrollOld } from '@fortawesome/pro-duotone-svg-icons'
import { Box } from '@mui/material'

import FilterMenu from '../shared/filterMenu/FilterMenu'
import {
  buildQuestFilterOptions,
  QUEST_FILTER_TYPE
} from '../../util/quest.helpers'
import QuestCard from './QuestCard'
import RecordsNotFound from '../shared/recordsNotFound/RecordsNotFound'
import PageTitle from '../shared/pageTitle/PageTitle'

const Quests = ({
  t,
  tokenProfile: { symbol },
  questProfile: { filterBy, active, completed, loading, error },
  onChangeFilterMenu,
  ...restProps
}) => {
  const isCompleted = filterBy === QUEST_FILTER_TYPE.COMPLETED
  const data = isCompleted ? completed : active
  const pageTitle = t('quest.quests')
  return (
    <>
      <PageTitle
        title={pageTitle}
        desc={t('quest.complete-following-quests', { symbol })}
      />
      <FilterMenu
        value={filterBy}
        options={buildQuestFilterOptions(t)}
        onChange={onChangeFilterMenu}
      />
      {data.length <= 0 ? (
        <RecordsNotFound
          icon={faScrollOld}
          description={t(`quest.no-${filterBy}-quests`)}
        />
      ) : (
        <Box
          sx={{
            gap: 3,
            display: 'grid',
            gridTemplateColumns: {
              xs: 'repeat(1, 1fr)',
              md: 'repeat(2, 1fr)'
            }
          }}
        >
          {data.map((data, index) => (
            <QuestCard
              {...data}
              t={t}
              loading={loading}
              error={error}
              symbol={symbol}
              key={index}
              {...restProps}
            />
          ))}
        </Box>
      )}
    </>
  )
}

export default memo(Quests)
